<template>
  <div class="box-card">
    <div class="search-form" style="text-align: left">
      <el-form ref="searchForm" :inline="true" :model="searchForm" label-width="70px" label-position="left"
        class="demo-form-inline" size="small">
          <el-form-item :label="$t('order.orderList.countryStateProvince')" label-width="80px">
            <el-cascader
              v-model='value1'
              :options="countryList"
              :props="{ checkStrictly: true }"
              @change="handleChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('order.orderList.receiveAddress')">
            <el-input clearable size="small" v-model="searchForm.address" :placeholder="$t('order.orderList.enterReceiveAddress')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('order.orderList.receiveAddressName')"  label-width="85px">
            <el-input clearable size="small" v-model="searchForm.receive_realname" :placeholder="$t('order.orderList.receiveAddressNameY')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('order.orderList.receivePhone')">
            <el-input clearable size="small" v-model="searchForm.receive_mobile" :placeholder="$t('order.orderList.enterReceivePhone')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('order.orderList.ecommerceOrderNo')" label-width="100px">
            <el-input clearable size="small" v-model="searchForm.hb_order_sn" :placeholder="$t('order.orderList.enterEcommerceOrderNo')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('order.orderList.logisticsOrderNo')" label-width="130px">
            <el-input clearable size="small" v-model="searchForm.porder_s" :placeholder="$t('order.orderList.batchSearchPlaceholder')" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item :label="$t('order.orderList.createTime')" prop="materielNameResult">
            <el-date-picker
              style="width:320px;"
              v-model="searchForm.createtime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              :start-placeholder="$t('order.orderList.startDate')"
              :end-placeholder="$t('order.orderList.endDate')">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" size="small" @click="handleSearch">{{ $t('order.orderList.query') }}</el-button>
            <el-button icon="el-icon-refresh-right" type="primary" size="small" @click="resetSearch">{{ $t('order.orderList.reset') }}</el-button>
          </el-form-item>
      </el-form>
    </div>
    <div class="" style="margin-bottom: 15px;text-align:left">
      <el-button type="primary" size="small" v-if='activeName == 4' @click="handleBatchOrder">{{ $t('order.orderList.batchCreateWaybill') }}</el-button>
      <el-button type="success" size="small" :loading="rateLoading" v-if='activeName == 4' @click="handleBatchOrderRate">{{ $t('order.orderList.batchEstimateFreight') }}</el-button>
      <el-button type="danger" size="small" v-if='activeName == 4' @click="handleDel">{{ $t('order.orderList.batchDelete') }}</el-button>
      <el-button type="danger" size="small" v-if='activeName == 1' @click="handleCancel">{{ $t('order.orderList.batchCancelOrder') }}</el-button>
      <el-button type="primary" size="small" @click="handleExport">{{ $t('order.orderList.exportData') }}</el-button>
      <el-button type="primary" size="small" v-if='[1, 2, 7, 8, 9, 10].includes(Number(activeName))' @click="handlePdfs">{{ $t('order.orderList.batchPrint') }}</el-button>
      <el-button type="warning" size="small" v-if='activeName == 4' @click="handleImportEx">{{ $t('order.orderList.importOrder') }}</el-button>
      <el-button type="primary" size="small" v-if='activeName == 4' @click="handleCheck">{{ $t('order.orderList.batchVerifyAddress') }}</el-button>
    </div>
    <el-table :data="dataList" ref="multipleTable" border size="small" height="500" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" :index="indexMethod" :label="$t('order.orderList.serialNo')" width="50"></el-table-column>
      <el-table-column prop="order_sn" :label="$t('order.orderList.orderNo')" show-overflow-tooltip width="180">
        <template slot-scope="scope">
          <div style="color: #409EFF;cursor: pointer;" @click="handleEdit(scope.row)">
            {{ scope.row.order_sn }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="hb_order_sn" :label="$t('order.orderList.ecommerceOrderNo')" width="140" show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('logistics.status')" width="180">
        <template slot-scope="scope">
          <el-tag size="small" :type="Number(scope.row.display_status) === 10 ? 'danger' : (Number(scope.row.display_status) === 9 ? 'success' : '')">{{ logisticsText(scope.row) }}</el-tag>
          <div v-if="scope.row.logistics_delivered_count > 0 && scope.row.logistics_delivered_count < scope.row.logistics_package_count">
            {{ $t('logistics.partialDelivered', { delivered: scope.row.logistics_delivered_count, total: scope.row.logistics_package_count }) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address_type" :label="$t('order.orderList.addressType')" v-if='activeName == 4'>
        <template slot-scope="scope">
          {{ scope.row.address_type == 1 ? $t('order.orderList.residential') : (scope.row.address_type == 2 ? $t('order.orderList.business') : '') }}
        </template>
      </el-table-column>
      <el-table-column align='center' :label="$t('order.orderList.logisticsInfo')">
        <el-table-column prop="platform_order_sn" :label="$t('order.orderList.logisticsNo')" show-overflow-tooltip width="170">
          <template slot-scope="scope">
            <div>
              <a v-if="canTrack(scope.row) && scope.row.service_type === 'U-S-UP'" style="text-decoration:none;color: #409EFF" :href="`https://www.ups.com/track?track=yes&trackNums=${scope.row.platform_order_sn}&loc=en_US&requester=ST/trackdetails`" target="_blank">{{ scope.row.platform_order_sn }}</a>
              <a v-else-if="canTrack(scope.row) && scope.row.service_type === 'U-S-DH'" style="text-decoration:none;color: #409EFF" :href="`https://www.dhl.com/cn-zh/home/tracking.html?tracking-id=${scope.row.platform_order_sn}`" target="_blank">{{ scope.row.platform_order_sn }}</a>
              <a v-else-if="canTrack(scope.row) && (scope.row.service_type === 'JD-YD' || scope.row.service_type === 'U-S-US')" style="text-decoration:none;color: #409EFF" :href="`https://tools.usps.com/go/TrackConfirmAction?tLabels=${scope.row.platform_order_sn}`" target="_blank">{{ scope.row.platform_order_sn }}</a>
              <a v-else-if="canTrack(scope.row) && isUps(scope.row.platform_order_sn)" style="text-decoration:none;color: #409EFF" :href="`https://www.ups.com/track?track=yes&trackNums=${scope.row.platform_order_sn}&loc=en_US&requester=ST/trackdetails`" target="_blank">{{ scope.row.platform_order_sn }}</a>
              <a v-else-if="canTrack(scope.row) && !isUps(scope.row.platform_order_sn)" style="text-decoration:none;color: #409EFF" :href="`https://www.fedex.com.cn/wtrk/track/?trknbr=${scope.row.platform_order_sn}`" target="_blank">{{ scope.row.platform_order_sn }}</a>
              <span v-else>{{scope.row.platform_order_sn}}</span>
              <i class="el-icon-document-copy copy-icon-btn" v-if="scope.row.platform_order_sn" @click="copy(scope.row.platform_order_sn)"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="service_type" :label="$t('order.orderList.logisticsProvider')" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="count_package" :label="$t('order.orderList.packageCount')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pa_lb" :label="$t('order.orderList.weight')" show-overflow-tooltip></el-table-column>
      </el-table-column>
      <el-table-column align='center' :label="$t('order.orderList.cost')">
        <el-table-column prop="rate_money" :label="$t('order.orderList.deductionAmount')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="fuel_money" :label="$t('order.orderList.fuelFee')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="address_money" :label="$t('order.orderList.remoteFee')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="itemized_price" :label="$t('order.orderList.residentialFee')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="insurance" :label="$t('order.orderList.insuranceAmount')" show-overflow-tooltip></el-table-column>
      </el-table-column>
      <el-table-column align='center' :label="$t('order.orderList.recipient')">
        <el-table-column prop="receive_country" :label="$t('order.orderList.country')" show-overflow-tooltip width="120"></el-table-column>
        <el-table-column prop="receive_province" :label="$t('order.orderList.stateProvince')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="address" :label="$t('order.orderList.address')" show-overflow-tooltip width="160"></el-table-column>
        <el-table-column prop="receive_realname" :label="$t('order.orderList.name')" show-overflow-tooltip width="120"></el-table-column>
        <el-table-column prop="receive_mobile" :label="$t('order.orderList.phone')" show-overflow-tooltip width="100"></el-table-column>
        <el-table-column prop="receive_zcode" :label="$t('order.orderList.postalCode')" show-overflow-tooltip></el-table-column>
      </el-table-column>
      <el-table-column prop="createtime" :label="$t('order.orderList.createDate')" show-overflow-tooltip width="120"></el-table-column>
      <el-table-column prop="check_status" :label="$t('order.orderList.verificationStatus')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="order_package_num" :label="$t('order.orderList.isMultiPackage')" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column prop="is_sign" :label="$t('order.orderList.isSignature')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.is_sign == 0 ? $t('order.orderList.no') : $t('order.orderList.yes') }}
          </template>
        </el-table-column>
        <el-table-column prop="is_international" :label="$t('order.orderList.isInternational')" width="90" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.is_international == 0 ? $t('order.orderList.no') : $t('order.orderList.yes') }}
          </template>
        </el-table-column>
        <el-table-column prop="is_qu" :label="$t('order.orderList.isScheduledPickup')" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.pickup_status == 1 || scope.row.pickup_confirmation ? $t('order.orderList.yes') : $t('order.orderList.no') }}
            <el-tooltip v-if="scope.row.pickup_status == 2 && !scope.row.pickup_confirmation" :content="scope.row.pickup_remark || $t('order.orderList.pickupFailed')" placement="top">
              <i class="el-icon-warning-outline" style="color: #E6A23C; cursor: help;"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="$t('order.orderList.pickupConfirmationCode')" width="180">
          <template slot-scope="scope">
            {{ (scope.row.pickup_location || '') + (scope.row.pickup_confirmation || '') }}
          </template>
        </el-table-column>
      <el-table-column prop="action" :label="$t('order.orderList.operation')" width="280" fixed="right">
        <template slot-scope="scope">
          <div>
            <span style="color: #67C23A; cursor: pointer" v-if='activeName != 4 && activeName != 5' @click="handleEdit(scope.row)">{{ $t('order.orderList.copyAsNewOrder') }}</span>
            <el-divider direction="vertical" v-if='activeName != 4 && activeName != 5'></el-divider>
            <span style="color: #E6A23C; cursor: pointer" v-if="scope.row.file_path" @click='handlePdf(scope.row)'>{{ $t('order.orderList.pdfFile') }}</span>
            <el-divider direction="vertical" v-if="scope.row.order_status == 1"></el-divider>
            <span style="color: #409eff; cursor: pointer" v-if="scope.row.order_status == 1" @click='handleDownPDF(scope.row)'>{{ $t('order.orderList.viewInvoice') }}</span>
            <el-divider direction="vertical" v-if="scope.row.file_path"></el-divider>
            <span style="color: #409eff; cursor: pointer" v-if="scope.row.platform_order_sn" @click='handleBar(scope.row.platform_order_sn)'>{{ $t('order.orderList.barcode') }}</span>
            <el-divider direction="vertical" v-if="scope.row.platform_order_sn"></el-divider>
            <span style="color: #F56C6C; cursor: pointer" @click='handleParcel(scope.row.order_id)'>{{ $t('order.orderList.packageInfo') }}</span>
            <el-divider direction="vertical" v-if="canPickup(scope.row)"></el-divider>
            <span
              style="color: #67c23a; cursor: pointer"
              v-if="canPickup(scope.row)"
              @click='handlePickup(scope.row)'
            >{{ $t('order.pickup.btn') }}<span v-if="scope.row.pickup_status == 1" style="color: #909399">({{ $t('order.pickup.statusBooked') }})</span></span>
            <el-divider direction="vertical" v-if="scope.row.order_status == 1 && scope.row.file_path== '' && scope.row.service_type == 'US022'"></el-divider>
            <span style="color: #F56C6C; cursor: pointer" v-if="scope.row.order_status == 1 && scope.row.file_path== '' && scope.row.service_type == 'US022'" @click='handleSheet(scope.row.order_id)'>{{ $t('order.orderList.getWaybill') }}</span>
            <el-divider direction="vertical" v-if="scope.row.is_store== 1"></el-divider>
            <span style="color: #409eff; cursor: pointer" v-if="scope.row.is_store== 1" @click='handleStore(scope.row.order_id)'>{{ $t('order.orderList.viewStoreShippingOrder') }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagization-box">
      <CustomPagization :background="true" :currentPage="current" :total="total" :pageSize="size"
        @current-change="currentChange" />
    </div>
    <!-- 查看门店发货单 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.orderList.viewStoreShippingOrderTitle')"
      append-to-body
      :visible.sync="storeVisible"
      width="110mm"
      :before-close="closeStoreDialog"
    >
      <Store
        v-if="storeVisible"
        :order_id='order_id'
        append-to-body
      />
    </el-dialog>
    <!-- PDF文件 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.orderList.viewPdfFileTitle')"
      append-to-body
      :visible.sync="pdfVisible"
      width="900px"
      :before-close="closePdfDialog"
    >
      <PDFs
        v-if="pdfVisible"
        :filePath='filePath'
        append-to-body
      />
    </el-dialog>
    <!-- 条形码 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.orderList.viewBarcodeTitle')"
      append-to-body
      :visible.sync="barVisible"
      :before-close="closeBarDialog"
    >
      <Barcode
        v-if="barVisible"
        :platform_order_sn='platform_order_sn'
        append-to-body
      />
    </el-dialog>
    <!-- 包裹信息 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.orderList.viewPackageInfoTitle')"
      append-to-body
      :visible.sync="parcelVisible"
      width="700px"
      :before-close="closeParcelDialog"
    >
      <Parcel
        v-if="parcelVisible"
        append-to-body
        :order_id='order_id'
      />
    </el-dialog>
    <!-- 面单 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="sheetTitle"
      append-to-body
      :visible.sync="sheetVisible"
      width="500px"
      :before-close="closeSheetDialog"
    >
      <Sheet
        v-if="sheetVisible"
        append-to-body
        :sheetList='sheetList'
      />
    </el-dialog>
    <!-- 编辑 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.orderList.editTitle')"
      append-to-body
      :visible.sync="splaceVisible"
      width="1280px"
      :before-close="closeSplaceDialog"
    >
      <Place
        v-if="splaceVisible && is_international === 0"
        :record='record'
        @orderSuccess='orderSuccess'
        append-to-body
      />
      <fPlace
        v-if="splaceVisible && is_international == 1"
        :record='record'
        @orderSuccess='orderSuccess'
        append-to-body
      />
    </el-dialog>
    <!-- 导入 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.orderList.importOrderTitle')"
      append-to-body
      :visible.sync="importVisible"
      width="500px"
      :before-close="closeImportDialog"
    >
      <ImportEx
        v-if="importVisible"
        :record='record'
        @uploadSuccess='uploadSuccess'
        append-to-body
      />
    </el-dialog>
      <!-- 批量打印 -->
          <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.orderList.batchPrintTitle')"
      append-to-body
      :visible.sync="morePdfsVisible"
      width="500px"
      :before-close="closeMorePdsDialog"
    >
      <MorePds
        v-if="morePdfsVisible"
        :morePdfs='morePdfs'
        :tip='morePdfsTip'
        @closeMorePds="closeMorePds"
        append-to-body
      />
    </el-dialog>
    <!-- 批量校验地址错误提示 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.orderList.verificationResultTitle')"
      append-to-body
      :visible.sync="errVisible"
      width="480px"
      :before-close="closeMsgDialog"
    >
      <Errmsg
        v-if="errVisible"
        :msgList='msgList'
        @msgBack='msgBack'
        append-to-body
      />
    </el-dialog>
    <!-- 表单弹窗 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.orderList.orderInvoiceTitle')"
      append-to-body
      :visible.sync="invoiceDetailVisible"
      width="1200px"
      :before-close="closeInvoiceDialog"
    >
      <InvoiceDetail
        ref="formModal"
        :order_sn="order_sn"
        :platform_order_sn="platformOrderSn"
        v-if="invoiceDetailVisible"
        append-to-body
      />
    </el-dialog>
    <!-- 预约取件弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.pickup.title')"
      append-to-body
      :visible.sync="pickupVisible"
      width="1100px"
      :before-close="closePickupDialog"
    >
      <Pickup
        v-if="pickupVisible"
        :orderId='pickupOrderId'
        @close="closePickupDialog"
        @success="onPickupSuccess"
        append-to-body
      />
    </el-dialog>
  </div>
</template>

<script>
  import { orderList, orderExport, cancelOrder, orderDel, batchOrder, batchOrderRate, labelinfo, print_pdf, checkaddress, labelInvoicePdf } from '@/api/order'
  import Barcode from './barcode.vue'
  import Parcel from './parcel.vue'
  import PDFs from './PDFs.vue'
  import Sheet from './sheet.vue'
  import Place from '../place.vue'
  import fPlace from '../fplace.vue'
  import ImportEx from './importEx.vue'
  import Errmsg from './errmsg.vue'
  import Store from './store.vue'
  import { transformCountryCity, downloadBase64AsExcel } from "@/common/common.js"
  import { City } from '@/api/common'
  import { usersInfo } from "@/api/user";
  import { mapState, mapActions } from 'vuex';
  import MorePds from './morePds.vue'
  import InvoiceDetail from '@/views/invoice/detailWrapper.vue';
  import Pickup from './pickup.vue';
  export default {
    components: {
      Barcode,
      Parcel,
      PDFs,
      Sheet,
      Place,
      fPlace,
      ImportEx,
      Store,
      MorePds,
      Errmsg,
      InvoiceDetail,
      Pickup
    },
    props: {
      activeName: {
        type: [Number,String],
        default: 0
      }
    },
    data() {
      return {
        is_international: 0,
        sheetTitle: '',
        morePdfs: '',
        morePdfsTip: '',
        platform_order_sn: '',
        rateLoading: false,
        pdfVisible: false,
        barVisible: false,
        parcelVisible: false,
        sheetVisible: false,
        splaceVisible: false,
        importVisible: false,
        storeVisible: false,
        morePdfsVisible: false,
        errVisible: false,
        invoiceDetailVisible: false,
        pickupVisible: false,
        pickupOrderId: null,
        order_sn: '',
        platformOrderSn: '',
        msgList: [],
        filePath: '', // pdf 链接
        sheetList: [],// 批量预估和批量打单数据
        order_id: '',
        record: {},
        searchForm: {},
        value1:[],
        current: 1,
        size: 200,
        total: 1,
        dataList: [],
        multipleSelection: [],
        countryList: [],// 国家-城市
      };
    },
    computed: {
      ids() {
        let ids = [];
        this.multipleSelection.forEach((ele) => {
          ids.push(ele.order_id);
        });
        return ids.join(",");
      },
      isUps(){
        return (num) => {
          // const regex = /^1Z[A-Z0-9]{16}$/;
          const regex = /^(?:1Z[A-Z0-9]{16}|4209004\d+)$/;
          return regex.test(num);
        }
      }
    },
    created() {
      this.sheetTitle = this.$t('order.orderList.estimateFreightTitle')
      this.getOrderList();
      this.getCity()
      this.getUsersInfo();
    },
    methods: {
      ...mapActions(['updateBalance','updateMoney']),
      logisticsText(row){
        return this.$t('logistics.status' + (row.display_status || row.order_status));
      },
      canTrack(row){
        return !!row.platform_order_sn && [1, 2, 6, 7, 8, 9, 10].includes(Number(row.display_status || row.order_status));
      },
      // 下载发票pdf
      handleDownPDF(row){
        this.order_sn = row.order_sn
        this.platformOrderSn = row.platform_order_sn || ''
        this.invoiceDetailVisible = true
      },
      // 关闭弹框
      closeInvoiceDialog() {
        this.order_sn = '';
        this.platformOrderSn = '';
        this.invoiceDetailVisible = false;
      },
      // 批量打印
      handlePdfs(){
        this.$confirm(this.$t('order.orderList.confirmPrintSelected'), this.$t('order.orderList.warmTip'), {
          type: "warning",
        })
        .then(() => {
          print_pdf({ 
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            ids: this.ids
          }).then(res => {
            if(res.code == 1){
              // 部分面单为不支持的压缩格式，未能合并：提示放进弹窗内，仍打开可打印的部分
              this.morePdfsTip = (res.data.failed && res.data.failed.length) ? res.msg : ''
              this.morePdfsVisible = true
              this.morePdfs = res.data.file 
            }else{
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {}); 
      },
      // 关闭批量打印
      closeMorePdsDialog(){
        this.morePdfsVisible = false
        this.morePdfsTip = ''
      },
      // 关闭批量打印
      closeMorePds(){
        this.morePdfsVisible = false
        this.morePdfsTip = ''
        this.current = 1
        this.getOrderList();
      },
      // 获取用户信息
      getUsersInfo() {
        usersInfo({ user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code }).then((res) => {
          if (res.code == 1) {
            this.updateBalance(res.data.userinfo.balance);
            this.updateMoney(res.data.userinfo.money)
          }
        });
      },
      // 查看门店发货信息
      handleStore(id){
        this.order_id = id  
        this.storeVisible = true          
      },
      // 关闭门店发货
      closeStoreDialog(){
        this.order_id = ''  
        this.storeVisible = false  
      },
      // 获取城市
      getCity(){
        City().then(res => {
          this.countryList = transformCountryCity(res.data)
        })
      },
      //获取省市县
      handleChange(value) {
        this.searchForm.country = value[0]
        if(value[1]){
          this.searchForm.province = value[1]
        }
      },
      // 查看PDF文件（面单）：国际单打开“面单+发票”合并后的单个 PDF（面单在前、发票在后，下拉即见发票）；国内单保持原样只打开面单
      handlePdf(row){
        if(!row) return
        // 国内单：直接打开面单 PDF，行为不变
        if(row.is_international != 1){
          this.filePath = row.file_path
          window.open(row.file_path, '_blank')
          return
        }
        // 国际单：调后端把面单和发票合并成一个 PDF 再打开
        // 先在当前点击手势内打开占位窗口，避免异步拿到地址后 window.open 被浏览器拦截
        const win = window.open('', '_blank')
        const loading = this.$loading({
          lock: true,
          text: this.$t('order.orderList.loadingLabelInvoice'),
          background: 'rgba(0, 0, 0, 0.5)'
        })
        labelInvoicePdf({
          user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
          order_id: row.order_id,
          order_sn: row.order_sn,
          platform_order_sn: row.platform_order_sn || ''
        }).then(res => {
          if(res.code == 1 && res.data && res.data.url){
            if(win){ win.location.href = res.data.url } else { window.open(res.data.url, '_blank') }
          }else{
            if(win) win.close()
            this.$message.error(res.msg || this.$t('order.orderList.getWaybillFail'))
          }
        }).catch(() => {
          if(win) win.close()
          this.$message.error(this.$t('order.orderList.getWaybillFail'))
        }).finally(() => {
          loading.close()
        })
      },
      // PDF文件弹窗
      closePdfDialog(){
        this.filePath = ''
        this.pdfVisible = false
      },
      // 查看条形码
      handleBar(platform_order_sn){
        this.platform_order_sn = platform_order_sn
        this.barVisible = true
      },
      // 关闭条形码弹窗
      closeBarDialog(){
        this.platform_order_sn = ''
        this.barVisible = false
      },
      // 查看包裹信息
      handleParcel(id){
        this.order_id = id
        this.parcelVisible = true
      },
      // 关闭包裹信息弹窗
      closeParcelDialog(){
        this.order_id = ''
        this.parcelVisible = false
      },
      // 导入
      handleImportEx(){
        this.importVisible = true
      },
      // 关闭导入
      closeImportDialog(){
        this.importVisible = false
      },
      // 查看面单
      handleSheet(id){
        labelinfo({
          user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
          order_id: id
        }).then(res => {
          if(res.code == 1){
            this.filePath = res.data.file_path
            // this.pdfVisible = true
            window.open(res.data.file_path, '_blank')
          }else{
            this.$message.error(res.msg);
          }
        }).catch(err => {
          this.$message.error(this.$t('order.orderList.getWaybillFail'));
        })
      },
      // 关闭面单弹窗
      closeSheetDialog(){
        this.sheetList = []
        this.sheetVisible = false
      },
      // 编辑
      handleEdit(row){
        this.record = row
        this.is_international = row.is_international
        this.splaceVisible = true
      },
      // 关闭编辑
      closeSplaceDialog(){
        this.record = {}
        this.splaceVisible = false
      },
      // 成功后回调
      orderSuccess(){
        this.splaceVisible = false
        this.current = 1
        this.getOrderList()
      },
      // 复制订单号
      copy(num){
        let oInput = document.createElement('input');
        oInput.value = num;
        document.body.appendChild(oInput);
        oInput.select();
        document.execCommand('Copy');
        this.$message.success(this.$t('order.orderList.copySuccess'));
        oInput.remove();
      },
      handleAdd(){},
      // 批量删除
      handleDel(){
        this.$confirm(this.$t('order.orderList.confirmDeleteSelected'), this.$t('order.orderList.warmTip'), {
          type: "warning",
        })
        .then(() => {
          orderDel({ 
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            ids: this.ids
          }).then(res => {
            if(res.code == 1){
              this.current = 1
              this.$message.success(res.msg);
              this.getOrderList();
            }else{
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
      },
      // 批量校验地址
      handleCheck(){
        this.$confirm(this.$t('order.orderList.confirmVerifySelectedAddress'), this.$t('order.orderList.warmTip'), {
          type: "warning",
        })
        .then(() => {
          checkaddress({ 
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            ids: this.ids
          }).then(res => {
            if(res.code == 1){
              this.current = 1
              this.$message.success(res.msg);
              this.getOrderList();
            }else{
              // this.$message.error(res.msg);
              this.msgList = res.msg.split(',')
              this.errVisible = true
            }
          });
        })
        .catch(() => {});
      },
      // 关闭批量提示
      closeMsgDialog(){
        this.msgList = []
        this.errVisible = false
        this.current = 1
        this.getOrderList();
      },
      // 点击批量校验提示
      msgBack(){
        this.msgList = []
        this.errVisible = false
        this.current = 1
        this.getOrderList();
      },
      // 批量取消
      handleCancel(){
        this.$confirm(this.$t('order.orderList.confirmCancelSelected'), this.$t('order.orderList.warmTip'), {
          type: "warning",
        })
        .then(() => {
          cancelOrder({ 
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            ids: this.ids
          }).then(res => {
            if(res.code == 1){
              this.current = 1
              this.$message.success(res.msg);
              this.getOrderList();
            }else{
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
      },
      // 批量生成打单
      handleBatchOrder(){
        this.$confirm(this.$t('order.orderList.confirmCreateWaybill'), this.$t('order.orderList.warmTip'), {
          type: "warning",
        })
        .then(() => {
          batchOrder({ 
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            ids: this.ids
          }).then(res => {
            if(res.data == null){
              this.$message.error(res.msg);
            }else if(res.data.error_msg.length > 0){
              this.sheetList = res.data.error_msg
              this.sheetTitle = this.$t('order.orderList.waybillTitle')
              this.sheetVisible = true
            }else{
              this.current = 1
              this.$message.success(res.msg);
              this.$emit('changelist','1')  
            }
          }).catch((err) => {
            if(err.data == null){
              this.$message.error(err.msg);
            }else if(err.data.error_msg.length > 0){
              this.sheetList = err.data.error_msg
              this.sheetTitle = this.$t('order.orderList.waybillTitle')
              this.sheetVisible = true
            }else{
              this.current = 1
              this.$message.success(err.msg);
              this.$emit('changelist','1')  
            }
          });;
        })
      },
      // 批量预估运费
      handleBatchOrderRate(){
        this.$confirm(this.$t('order.orderList.confirmEstimateFreight'), this.$t('order.orderList.warmTip'), {
          type: "warning",
        })
        .then(() => {
          this.rateLoading = true
          batchOrderRate({ 
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            ids: this.ids
          }).then(res => {
            this.rateLoading = false
            if(res.data == null){
              this.$message.error(res.msg);
            }else if(res.data.error_msg.length > 0){
              this.sheetList = res.data.error_msg
              this.sheetTitle = this.$t('order.orderList.estimateFreightTitle')
              this.sheetVisible = true
            }else{
              this.current = 1
              this.$message.success(res.msg);
              this.getOrderList();
            }
          }).catch((err) => {
            this.rateLoading = false
            if(err.data == null){
              this.$message.error(err.msg);
            }else if(err.data.error_msg.length > 0){
              this.sheetList = err.data.error_msg
              this.sheetTitle = this.$t('order.orderList.estimateFreightTitle')
              this.sheetVisible = true
            }else{
              this.current = 1
              this.$message.success(err.msg);
              this.getOrderList();
            }
          });;
        })

      },
      handleSelectionChange(e){
        this.multipleSelection = e
      },
      // 导出数据
      handleExport(){
        let queryForm = {}
        if(this.searchForm.createtime){
          queryForm = {
            ...this.searchForm,
            createtime: this.searchForm.createtime.join("/")
          }
        }else{
          queryForm = {
            ...this.searchForm
          }
        }
        orderExport({
          user_code:JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
          order_status: this.activeName,
          ...queryForm
        }).then(res => {
          downloadBase64AsExcel(res.data.file,res.data.name)
        })
      },
      // 多选
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      // 关闭弹框
      closeDialog() {
        this.record = {};
        this.formVisible = false;
      },
      //新增、修改成功的回调
      editSuccess() {
        this.formVisible = false;
        this.getOrderList();  //刷新列表
      },
      uploadSuccess(){
        this.importVisible = false
        this.current = 1
        this.getOrderList()
      },
      // 获取列表
      getOrderList(){
        let queryForm = {}
        if(this.searchForm.createtime){
          queryForm = {
            ...this.searchForm,
            createtime: this.searchForm.createtime.join("/")
          }
        }else{
          queryForm = {
            ...this.searchForm
          }
        }
        orderList({
          user_code:JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
          page: this.current,
          limit: this.size,
          order_status: this.activeName,
          ...queryForm
        }).then(res => {
          if(res.code == 1){
            this.dataList = res.data.list
            this.total = res.data.total
          }
        })
      },
      // table首列序号
      indexMethod(index) {
        return (this.current - 1) * this.size + index + 1;
      },
      // 页数变化
      currentChange(current) {
        this.current = current;
        this.getOrderList();
      },
      // 重置筛选
      resetSearch() {
        this.$refs["searchForm"].resetFields();
        this.searchForm = {}
        this.value1 = []
        this.current = 1;
        this.total = 1;
        this.dataList = [];
        this.handleSearch();
      },
      // 去筛选
      handleSearch() {
        this.current = 1;
        this.total = 1;
        this.dataList = [];
        this.getOrderList();
      },
      // 跳往轨迹
      search(num){
        this.$router.push({ path: '/trace', query: { num:num } });
      },
      // 是否显示预约取件按钮（待发货 + 已付款 + 已打单 + FedEx/UPS 官方渠道）
      canPickup(row){
        if (this.activeName != 1) return false;
        if (Number(row.order_status) !== 1 || Number(row.logistics_has_movement) === 1 || Number(row.display_status || row.order_status) !== 1) return false;
        const allow = ['JD-FED', 'ZD-FED', 'JD-UPS', 'ZD-UPS'];
        if (!allow.includes(row.service_type)) return false;
        if (Number(row.pay_status) !== 1) return false;
        if (!row.platform_order_sn) return false;
        return true;
      },
      // 打开预约取件弹窗
      handlePickup(row){
        this.pickupOrderId = row.order_id;
        this.pickupVisible = true;
      },
      // 关闭预约取件弹窗
      closePickupDialog(){
        this.pickupVisible = false;
        this.pickupOrderId = null;
      },
      // 预约成功回调
      onPickupSuccess(data){
        this.pickupVisible = false;
        this.pickupOrderId = null;
        this.getUsersInfo();   // 刷新余额
        this.getOrderList();   // 刷新订单
      },
    },
  };
</script>
<style lang="scss" scoped>
.pagization-box {
  overflow: hidden;
  margin-top: 10px;

  .el-pagination {
    float: right;
  }
}
/deep/ {
  .el-table {
    thead {
      color: #fff;
      font-weight: 500;
      background: #F5F7FA;
      color: #606266;
      & th {
        background-color: transparent;
      }
      & tr {
        background-color: transparent;
      }
    }
  }
}
/deep/.el-dialog__body{
  padding: 0 20px 20px!important;
}
.copy-icon-btn{
  font-size: 16px;
  margin-left: 10px;
  color:#409EFF;
  cursor: pointer;
}
</style>
